module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
    'use strict';

    fox.registerWidget('PeriodSelector', {

        configure: function () {
            this.period = {};

            this.registerOptions('', {
                'embed.container': '#period-selector',
                template: 'component_period_selector',
                returnedDateFormat: '%Y-%m-%d',
                allowSameDates: false,
                autoRender: true,
                widgets: {
                    dateFrom: {
                        widget: 'CustomDatepicker',
                        'embed.container': '#date-from',
                        autoRender: true,
                        initialDate: '-1m',
                        group: 'datepickers'
                    },
                    dateTo: {
                        widget: 'CustomDatepicker',
                        'embed.container': '#date-to',
                        autoRender: true,
                        group: 'datepickers'
                    }
                },
                handleWom: {
                    selectDate: {
                        event: 'selectDate',
                        widget: '.CustomDatepicker',
                        callback: 'selectDate'
                    },
                    onYearMonthChange: {
                        event: 'on_year_month_change',
                        widget: '.CustomDatepicker',
                        callback: function (data, performer) {
                            if (performer.alias === 'dateTo') {
                                this.maxYear = Number(data.y);
                            } else {
                                this.minYear = Number(data.y);
                            }

                            this.restrictDateChoice(performer.alias);
                        }
                    }
                }
            });
        
            this.callParent('configure', arguments);
        },

        init: function () {
            var isNewSelect = this.getOption('newSelect');
            var clear = this.getOption('clear');

            if (isNewSelect) {
                this.registerOptions('.CustomDatepicker', {
                    'templateOptions.newSelect': isNewSelect,
                    'templateOptions.clear': clear,
                    newSelect: isNewSelect,
                });
            }

            this.callParent('init', arguments);
        },

        selectDate: function (params, scope) {
            fox.each(this.getWidgetsByGroup('datepickers'), function (w, alias) {
                this.period[alias] = w.selectedDate;
            }, this);

            var period = this.period;
            
            if (scope.alias === 'dateFrom') {
                if (!period.dateTo) {
                    period.dateTo = new Date(
                        period.dateFrom.getFullYear(),
                        period.dateFrom.getMonth(),
                        period.dateFrom.getDate() - 1
                    );
                }

                this.fillRestrictionDate();
                this.restrictDateChoice('dateTo');
            } else if (scope.alias === 'dateTo') {
                if (!period.dateFrom) {
                    period.dateFrom = new Date(
                        period.dateTo.getFullYear(),
                        period.dateTo.getMonth(),
                        period.dateTo.getDate() + 1
                    );
                }

                this.fillRestrictionDate();
                this.restrictDateChoice('dateFrom');
            }

            if (this.getOption('allowSameDates') || this.diffDates()) {
                this.applyRange();
            } else {
                this.discardRange();
            }
        },

        applyRange: function () {
            this.dispatchEvent('applyRange', this.getParamsForApi());
        },

        getParamsForApi: function () {
            var dateFormat = this.getOption('returnedDateFormat');

            return {
                dateFrom: this.period.dateFrom ? fox.utils.dateFormat(dateFormat, this.period.dateFrom) : this.period.dateFrom,
                dateTo:  this.period.dateTo ? fox.utils.dateFormat(dateFormat, this.period.dateTo) :  this.period.dateTo
            };
        },

        discardRange: function () {
            console.warn('dateTo < dateFrom');
            this.dispatchEvent('discardRange');
        },

        diffDates: function () {
            return (this.period.dateTo.getTime() - this.period.dateFrom.getTime()) > 0;
        },

        childAddedToDom: function (resp) {
            this.period[resp.performer.getAlias()] = resp.performer.selectedDate;
            this.dispatchEvent('childAddedToDom', this.period);

            return resp;
        },

        afterEmbed: function() {
            var args = fox.clone(arguments);

            fox.RSVP.all([
                this.wait('#dateFrom', 'addedToDom', {prefix: 'wait_for_child'}).then(this.childAddedToDom.bind(this)),
                this.wait('#dateTo', 'addedToDom', {prefix: 'wait_for_child'}).then(this.childAddedToDom.bind(this))
            ]).then(function(dps) {
                this.fillRestrictionDate();
                this.restrictDateChoice('dateFrom');
                this.restrictDateChoice('dateTo');
                this.dispatchEvent('childrenAddedToDom', this.period);
                this.callParent('afterEmbed', args);
            }.bind(this));

            this.callParent('afterEmbed', args);
        },

        isEmbedded: function () {
            return this.callParent('isEmbedded', arguments) &&
                this.rwom1('#dateFrom').isEmbedded() &&
                this.rwom1('#dateTo').isEmbedded();
        },

        fillRestrictionDate: function () {
            if (this.period.dateFrom) {
                this.minDate = this.period.dateFrom;
                this.minMonth = this.period.dateFrom.getMonth() + 1;
                this.minYear = this.period.dateFrom.getFullYear();
            }
            
            if (this.period.dateTo) {
                this.maxDate = this.period.dateTo;
                this.maxMonth = this.period.dateTo.getMonth() + 1;
                this.maxYear = this.period.dateTo.getFullYear();
            }
        },

        restrictDateChoice: function (target) {
            var datepicker = this.rwom1('#' + target);
            var targetValue = target === 'dateTo' ? 'min' : 'max';
            
            datepicker.dp.datepicker('option', targetValue + 'Date', this[targetValue + 'Date']);

            function rMonths($options) {
                $options.each(function (idx, option) {
                    if (targetValue === 'min') {
                        option.disabled = option.value < this[targetValue + 'Month'] &&
                            this.minYear === this.maxYear ? true : false;
                    } else {
                        option.disabled = option.value > this[targetValue + 'Month'] &&
                            this.minYear === this.maxYear ? true : false;
                    }
                    
                    if (this.getOption('newSelect') && option.value.length) {
                        var $node = $(option).parent().parent().find('.dropdown-list [data-value=' + option.value + ']');

                        $node[option.disabled ? 'addClass' : 'removeClass']('disabled');
                    }
                }.bind(this));
            }

            function rYears($options) {
                $options.each(function (idx, option) {
                    if (targetValue === 'min') {
                        option.disabled = option.value < this[targetValue + 'Year'] ? true : false;
                    } else {
                        option.disabled = option.value > this[targetValue + 'Year'] ? true : false;
                    }

                    if (this.getOption('newSelect') && option.value.length) {
                        var $node = $(option).parent().parent().find('.dropdown-list [data-value=' + option.value + ']');

                        $node[option.disabled ? 'addClass' : 'removeClass']('disabled');
                    }
                }.bind(this));
            }

            if (this.getOption('newSelect')) {
                ['month', 'year'].forEach(function (alias) {
                    var select = datepicker.rwom1('#' + alias);

                    if (select.isEmbedded()) {
                        if (alias === 'month') {
                            rMonths.call(this, datepicker.$dpw.find('[name=month] option'));
                        }
                        if (alias === 'year') {
                            rYears.call(this, datepicker.$dpw.find('[name=year] option'));
                        }
                    } else {
                        select.wait('addedToDom').then(function () {
                            if (alias === 'month') {
                                rMonths.call(this, datepicker.$dpw.find('[name=month] option'));
                            }
                            if (alias === 'year') {
                                rYears.call(this, datepicker.$dpw.find('[name=year] option'));
                            }
                        }.bind(this));
                    }
                }, this);
            } else {
                rMonths.call(this, datepicker.$dpw.find('.datepicker-month option'));
                rYears.call(this, datepicker.$dpw.find('.datepicker-year option'));
            }
        },

        eachDatepickers: function (cb) {
            fox.each(this.getWidgetsByGroup('datepickers'), cb, this);
        }

    }, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/periodSelector.js
// module id = 336
// module chunks = 2